/* eslint-disable @typescript-eslint/no-floating-promises */
import { useEffect } from 'react';
import { VideoEffectStore } from '../store/videoEffectModel';

export function useCollaboratorPreferences() {
  const fetchPreferences = VideoEffectStore.useStoreActions((actions) => actions.fetchPreferences);

  useEffect(() => {
    fetchPreferences();
  }, [fetchPreferences]);
}
